module.exports = __webpack_public_path__ + "img/luggage.ec0c36bd.svg";